import { useCallback, useEffect, useState } from "react";
import { api, formatDateTime } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PageHeader } from "@/components/Stat";
import { DataTable } from "@/components/DataTable";

const TYPES = ["Vehicle", "VehicleExpense", "VehicleSale", "VehiclePurchase", "VehicleMovement", "ConstructionProject", "ProjectCost",
  "ProjectSale", "ProjectStage", "ExcavationJob", "ExcavationTrip", "ExcavationCost", "Payment", "GeneralExpense", "GeneralIncome",
  "Customer", "Supplier", "Employee", "User"];
const ACTIONS = { create: "Oluşturma", update: "Güncelleme", archive: "Arşiv / İptal" };
const TYPE_TR = { Vehicle: "Araç", VehicleExpense: "Araç Masrafı", VehicleSale: "Araç Satışı", VehiclePurchase: "Araç Alışı",
  VehicleMovement: "Araç Hareketi", ConstructionProject: "İnşaat Projesi", ProjectCost: "Proje Maliyeti", ProjectSale: "Bölüm Satışı",
  ProjectStage: "Proje Aşaması", Material: "Malzeme", ExcavationJob: "Hafriyat İşi", ExcavationTrip: "Hafriyat Seferi",
  ExcavationCost: "Hafriyat Gideri", Payment: "Ödeme", GeneralExpense: "Genel Gider", GeneralIncome: "Genel Gelir",
  Customer: "Müşteri", Supplier: "Tedarikçi", Employee: "Personel", User: "Kullanıcı", Subcontractor: "Taşeron", Equipment: "Ekipman" };

export default function AuditLog() {
  const [type, setType] = useState("all");
  const [skip, setSkip] = useState(0);
  const [data, setData] = useState({ items: [], total: 0 });
  const limit = 50;
  const load = useCallback(() => {
    api.get("/audit-logs", { params: { entity_type: type === "all" ? undefined : type, skip, limit } }).then((r) => setData(r.data));
  }, [type, skip]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-6" data-testid="audit-page">
      <PageHeader title="İşlem Geçmişi" subtitle="Kritik tüm değişiklikler kim, ne zaman, ne yaptı bilgisiyle kaydedilir" />
      <Card className="p-4 space-y-4">
        <Select value={type} onValueChange={(v) => { setType(v); setSkip(0); }}>
          <SelectTrigger className="w-56" data-testid="audit-type-filter"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="all">Tüm Kayıt Türleri</SelectItem>{TYPES.map((t) => <SelectItem key={t} value={t}>{TYPE_TR[t]}</SelectItem>)}</SelectContent>
        </Select>
        <DataTable testIdPrefix="audit-row" rows={data.items} empty="Kayıt yok" columns={[
          { key: "created_at", label: "Zaman", render: (a) => <span className="whitespace-nowrap">{formatDateTime(a.created_at)}</span> },
          { key: "user_name", label: "Kullanıcı", className: "font-medium" },
          { key: "action", label: "İşlem", render: (a) => ACTIONS[a.action] || a.action },
          { key: "entity_type", label: "Kayıt Türü", render: (a) => TYPE_TR[a.entity_type] || a.entity_type },
          { key: "summary", label: "Açıklama" }]} />
        <div className="flex items-center justify-end gap-2 text-sm">
          <Button size="sm" variant="outline" disabled={skip === 0} onClick={() => setSkip(skip - limit)} data-testid="audit-prev">Önceki</Button>
          <span>{data.total ? skip + 1 : 0}-{Math.min(skip + limit, data.total)} / {data.total}</span>
          <Button size="sm" variant="outline" disabled={skip + limit >= data.total} onClick={() => setSkip(skip + limit)} data-testid="audit-next">Sonraki</Button>
        </div>
      </Card>
    </div>
  );
}
